<script setup lang="ts">
import { ref } from 'vue';
import i18n from '@/i18n';
import { getEnvVar } from '@/utils';
import { useComponentComposable } from '@/components/useComponentComposable';
import Dialog from 'primevue/dialog';
import ShowImageByScreen from '@/components/ShowImageByScreen.vue';
import LongParagraphModal from '@/components/modal/utils/LongParagraphModal.vue';

interface Props {
  valuePromoCard: any;
}
defineProps<Props>();

const { renderHTMLContent } = useComponentComposable();
const visible = ref(false);

const handleRedirect = () => {
  const hybrisUrl = getEnvVar('VITE_JWT_ISS');
  const currentLanguage = i18n.global.locale.value;
  const linkGroupForm = currentLanguage === 'fr' ? new URL('fr/formulaire-de-groupe', `${hybrisUrl}`) : new URL(`en/group-form`, `${hybrisUrl}`);
  window.open(linkGroupForm, '_blank');
};
</script>
<template>
  <div class="bigtile-link-wrapper">
    <div class="img-wrapper">
      <ShowImageByScreen alt="" class="img-responsive" :images="valuePromoCard?.imageList"></ShowImageByScreen>
    </div>
    <!-- DEV TODO: @click must also work on keydown (Enter) to be accessible;
    It would be better for this to be a <a href=""> since semantically it IS a link to another page -->
    <div class="title cursor-pointer" role="link" tabindex="0" @click="handleRedirect()">
      <renderHTMLContent :data="valuePromoCard.title"></renderHTMLContent>
    </div>
    <div class="content">
      <div class="content-block">
        <LongParagraphModal :maxCharacters="100000" class-component="pb-2" :text="valuePromoCard?.description" />
      </div>

      <div class="content-block">
        <!-- DEV TODO: @click must also work on keydown (Enter) to be accessible;
        It would be better for this to be a <button> since semantically it IS a button that launches a modal -->
        <a role="button" tabindex="0" class="modal-link tAndC cursor-pointer underline text-blue-600" @click="visible = true">{{ $t('promos.labels.term') }}</a>
        <Dialog :header="$t('common.termcondition')" v-model:visible="visible" :modal="true" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" class="tcs dialog-prime">
          <renderHTMLContent class="text-12px text-semiblack" :data="valuePromoCard?.terms" />
        </Dialog>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.promo-listing-wrapper .content .content-block > .modal-link {
  font-size: 1.4rem;
}

.tcs.dialog-prime {
  width: 50vw;
  background-color: white;

  .p-dialog-header,
  .p-dialog-content {
    background: transparent;
  }

  .p-dialog-title {
    font-family: $font-med19;
    font-size: 1.8rem;
    font-weight: normal;
    line-height: 1.1;
    color: $col-black;
  }

  .p-dialog-header-actions {
    position: absolute;
    right: 0;
  }
}
</style>
